export default __webpack_public_path__ + "static/media/skyship5.d07dccc1.webp";